module.exports = __webpack_public_path__ + "static/media/43.b4ae4686.webp";